<template>
  <div class="share-carousel">
    <h2>商品分享管理</h2>
    <!-- URL Input -->
    <div class="url-input-container">
      <input 
        v-model="sourceUrl"
        @keyup.enter="generatePreview"
        placeholder="輸入 Google 商品表單 URL"
        class="url-input"
      />
      <button 
        @click="generatePreview"
        :disabled="!sourceUrl || isLoading"
        class="generate-button"
      >
        生成預覽
      </button>
    </div>

    <!-- Flex Message Preview -->
    <div class="flex-preview" v-if="flexMessage && flexMessage.contents && flexMessage.contents.contents">
      <div class="carousel-container">
        <div class="carousel-wrapper">
          <div 
            v-for="(bubble, index) in flexMessage.contents.contents" 
            :key="index"
            class="bubble-card"
          >
            <!-- Header -->
            <div class="bubble-header">
              <img :src="bubble.header.contents[0].url" :alt="bubble.body.contents[0].text">
              <div class="recommendation-badge"><span>{{ bubble.header.contents[1].contents[0].text }}</span></div>
            </div>
            
            <!-- Body -->
            <div class="bubble-body">
              <p>{{ bubble.body.contents[0].text }}</p>
            </div>

            <!-- Footer -->
            <div class="bubble-footer">
              <div class="price-info">
                <span class="original-price">{{ bubble.footer.contents[0].contents[0].text }}</span>
                <span class="sale-price">{{ bubble.footer.contents[0].contents[1].text }}</span>
              </div>
              <div class="d-flex align-items-center justify-content-end">
                <div class="seller">{{ bubble.footer.contents[1].contents[1].contents[0].text }}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <button 
      @click="handleShare" 
      :disabled="isSharing || !flexMessage"
      class="share-button"
    >
      分享商品
    </button>
    <button @click="sendToSelf"
      :disabled="isSharing || !flexMessage"
      class="share-button">傳送給自己</button>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from 'axios';
import liff from '@line/liff';
import { showModal } from '@/utils/modal'

export default {
  name: 'ShareCarousel',
  setup() {
    const store = useStore();
    const router = useRouter();
    const sourceUrl = ref('');
    const flexMessage = ref(null);
    const isSharing = ref(false);
    const isLoading = ref(false);

    onMounted(async () => {
      const userId = store.getters.userId;
      if (!userId) {
        router.push('/me?page=share_management');
        return;
      }
    });

    const generatePreview = async () => {
      if (!sourceUrl.value) return;
      
      isLoading.value = true;
      try {
        // Custom template options
        const options = {
            template: {
                fieldMappings: {
                title: "商品名稱",
                image: "商品圖片網址",
                originalPrice: "廠商價",
                salePrice: "優惠價",
                seller: "廣告主",
                owner: "Owner",
                url: "參考連結"
                },
                template: {
                  type: "bubble",
                  size: "micro",
                  header: {
                    type: "box",
                    layout: "vertical",
                    contents: [
                      {
                        type: "image",
                        url: "${image}",
                        size: "full",
                        aspectRatio: "1:1",
                        aspectMode: "cover"
                      },
                      {
                        type: "box",
                        layout: "vertical",
                        contents: [
                          {
                            type: "text",
                            text: "${owner}",
                            size: "xxs",
                            color: "#ffffff",
                            weight: "bold"
                          }
                        ],
                        position: "absolute",
                        height: "20px",
                        backgroundColor: "#ff6b35",
                        cornerRadius: "20px",
                        offsetTop: "8px",
                        justifyContent: "center",
                        alignItems: "center",
                        offsetStart: "8px",
                        paddingStart: "md",
                        paddingEnd: "md"
                      }
                    ],
                    paddingAll: "none",
                    action: {
                      type: "uri",
                      label: "item image",
                      uri: "${url}"
                    }
                  },
                  body: {
                    type: "box",
                    layout: "vertical",
                    contents: [
                      {
                        type: "text",
                        text: "${title}",
                        size: "xs",
                        wrap: true,
                        maxLines: 2
                      }
                    ],
                    paddingBottom: "none",
                    paddingAll: "md"
                  },
                  footer: {
                    type: "box",
                    layout: "vertical",
                    contents: [
                      {
                        type: "box",
                        layout: "horizontal",
                        contents: [
                          {
                            type: "text",
                            text: "${originalPrice}",
                            wrap: false,
                            size: "xxs",
                            flex: 0,
                            decoration: "line-through",
                            color: "#999999"
                          },
                          {
                            type: "text",
                            text: "${salePrice}",
                            weight: "bold",
                            color: "#cc0000",
                            margin: "xs",
                            wrap: false
                          }
                        ],
                        alignItems: "center",
                        margin: "xs"
                      },
                      {
                        type: "box",
                        layout: "horizontal",
                        contents: [
                          {
                            type: "filler",
                            flex: 1
                          },
                          {
                            type: "box",
                            layout: "horizontal",
                            contents: [
                              {
                                type: "text",
                                text: "${seller}",
                                flex: 0,
                                size: "xxs",
                                color: "#777777",
                                wrap: false
                              }
                            ],
                            alignItems: "center",
                            spacing: "sm",
                            backgroundColor: "#EAEDF7",
                            cornerRadius: "10px",
                            height: "20px",
                            flex: 0,
                            paddingStart: "md",
                            paddingEnd: "md",
                            justifyContent: "center"
                          }
                        ],
                        margin: "xs",
                        paddingBottom: "xs"
                      }
                    ],
                    paddingTop: "none",
                    paddingAll: "md"
                  }
                }
            }
        };

        const response = await axios.get('https://scrap-helpper-69957198502.asia-east1.run.app/', {
          params: {
            url: sourceUrl.value,
            options: JSON.stringify(options)
          }
        });
        flexMessage.value = response.data;
      } catch (error) {
        console.error('Failed to generate preview:', error);
      } finally {
        isLoading.value = false;
      }
    };

    const handleShare = async () => {
      if (!liff.isApiAvailable('shareTargetPicker')) {
        alert('分享功能目前尚未開放喔！');
        return;
      }

      isSharing.value = true;
      
      try {
        const messageToShare = JSON.parse(JSON.stringify(flexMessage.value));
        const result = await liff.shareTargetPicker([messageToShare]);
        if (result) {
          console.log('Message shared successfully');
        }
      } catch (error) {
        console.error('Share failed:', error);
      } finally {
        isSharing.value = false;
      }
    };

    const sendToSelf = async () => {
      isSharing.value = true;
      
      try {
        // 1. 檢查是否在 LIFF 環境
        if (!liff.isInClient()) {
          throw new Error("必須在 LINE APP 中開啟");
        }

        // 2. 檢查並請求發送訊息權限
        const hasPermission = await liff.permission.query("chat_message.write");
        if (!hasPermission) {
          const requestResult = await liff.permission.request("chat_message.write");
          if (!requestResult) {
            throw new Error("未取得發送訊息權限");
          }
        }

        // 3. 發送訊息
        const messageToSend = JSON.parse(JSON.stringify(flexMessage.value));
        await liff.sendMessages([messageToSend]);
        
        // 4. 成功處理
        showModal('訊息已發送');

      } catch (error) {
        // 5. 錯誤處理
        console.error('發送訊息失敗:', error);
        showModal(error.message || '發送失敗，請稍後再試');
      } finally {
        isSharing.value = false;
      }
    };

    return {
      sourceUrl,
      flexMessage,
      isSharing,
      isLoading,
      generatePreview,
      handleShare,
      sendToSelf
    };
  }
}
</script>

<style scoped>
.share-carousel {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.url-input-container {
  display: flex;
  gap: 8px;
}

.url-input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.generate-button {
  padding: 8px 16px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.generate-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.flex-preview {
  margin: 20px 0;
  overflow: hidden;
}

.carousel-container {
  width: 100%;
  overflow-x: auto;
  padding: 20px 0;
}

.carousel-wrapper {
  display: flex;
  gap: 9px;
  padding: 0 8px;
}

.bubble-card {
  width: 160px;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: 1px 2px 6px rgba(0,0,0,0.1);
  flex-shrink: 0;
}

.bubble-header {
  position: relative;
  width: 100%;
  padding-top: 100%;
}

.bubble-header img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.recommendation-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ff6b35;
  color: white;
  padding: 4px 8px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: bolder;
}
.recommendation-badge span {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.bubble-body {
  padding: 8px;
  padding-bottom: 0;
}

.bubble-body p {
  font-size: 13px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 0;
}

.bubble-footer {
  padding: 8px;
  padding-top: 0;
}

.price-info {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.original-price {
  font-size: 11px;
  color: #999;
  text-decoration: line-through;
}

.sale-price {
  font-size: 16px;
  color: #cc0000;
  font-weight: bolder;
  margin-left: 2px;
}

.seller {
  background: #EAEDF7;
  color: #777;
  padding: 4px 8px;
  border-radius: 10px;
  font-size: 11px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.share-button {
  padding: 10px 20px;
  background-color: #00a8ca;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}

.share-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
</style>
